import { PayloadAction } from '@reduxjs/toolkit';
import { PlanboardState } from '@reducers/v2/planboard/types';

export const removePendingOperationAction = (state: PlanboardState, action: PayloadAction<number>) => {
  delete state.pendingOperations[action.payload];
};
